module.exports = __webpack_public_path__ + "static/media/solutions-sm.b28f8c90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headers/solutions-sm.jpg
// module id = 157
// module chunks = 11